import React, { useState } from 'react';
import '../styles/ClientPortal.css';
import Login from '../components/auth/Login';
import Dashboard from '../components/dashboard/Dashboard';

function ClientPortal() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <div className="sp-client-portal">
      {isAuthenticated ? <Dashboard /> : <Login onLogin={handleLogin} />}
    </div>
  );
}

export default ClientPortal;